import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { TextInput } from "colbi_web_ui/lib/components/inputs";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { FORM_ACTIONS } from "../FormActions";
import styles from "./PackageForm.module.sass";
import { datetime } from "../../../utils";
import { DescriptionsLocales } from "../../../components";

const PackageForm = (props, ref) => {
    const { data, status, onChange, onSave } = props;
    const { name, description, createdAt, updatedAt } = data || {};
    const formRef = useRef();
    const { i18n } = useGlobalValue();

    const handleChange = (e, prop, value) => {
        onChange &&
            onChange({
                originalEvent: e,
                target: {
                    value: {
                        data: {
                            ...data,
                            [prop]: value,
                        },
                    },
                },
            });
    };
    useImperativeHandle(ref, () => ({
        submit: () => {
            formRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        },
    }));

    function statusCheck(modalStatus) {
        return modalStatus !== "loading";
    }

    return statusCheck(status) ? (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (formRef.current.checkValidity()) {
                    !name && handleChange(e, "name", "");
                    onSave && onSave();
                } else {
                    formRef.current.reportValidity();
                }
            }}
        >
            <div className={styles["group-content"]}>
                <div className={styles["input-field"]}>
                    <TextInput
                        className={styles["input"]}
                        name={i18n`Package Name`}
                        placeholder={i18n`Enter a Package Name`}
                        value={name || ""}
                        required
                        onChange={(e) => {
                            handleChange(e, "name", e.target.value);
                        }}
                    />
                </div>
                <DescriptionsLocales
                    handleChange={handleChange}
                    jsonObject={description}
                    keyToChange={"description"}
                    inputTitle={"Description"}
                    inputPlaceholder={"Enter a Description"}
                    containerTitle={"Descriptions"}
                />
                <div className={styles["group-content"]}>
                    <div className={styles["flex"]}>
                        <div className={styles["input-field"]}>
                            <TextInput
                                className={styles["input"]}
                                name={i18n`Created At`}
                                defaultValue={datetime(createdAt) || ""}
                                disabled
                            />
                        </div>
                        <div className={styles["input-field"]}>
                            <TextInput
                                className={styles["input"]}
                                name={i18n`Updated At`}
                                defaultValue={datetime(updatedAt) || ""}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    ) : null;
};

const PackageFormRef = forwardRef(PackageForm);

PackageFormRef.queries = (args) => {
    return [
          {
            resource: "package",
            args: {
                packageId: args.id || 0,
            },
            body: "__typename,id,name,description,createdAt,updatedAt",
        }
    ].filter((q) => q);
};

PackageFormRef.dataMapper = ["data"];

PackageFormRef.actions = [FORM_ACTIONS.SAVE];

export default PackageFormRef;
